import Record from "./record";

export default class GambleInitRecord extends Record {
    public gambleID: number;
}
